import apiRequest from "../../helpers/apiRequest";

export default async (obj) => {
    return await apiRequest({
        method: 'post',
        url: `content/confirm/indvidual/appointment/`,
        data: obj
    });
}
